import { StageMetricCard, NoDataFound, Card, stageColor, pctOfLeads } from "./Common";

export default function FunnelCards({ stages }) {
  if (!stages?.length) {
    return (
      <Card className="p-4 mb-4">
        <NoDataFound label="No pipeline stages yet" />
      </Card>
    );
  }

  // Leads (the first stage) is the fixed 100% baseline -- every other stage's
  // badge is "% of total leads that reached here", not "% of the stage before it".
  const leadsTotal = stages[0].total;

  return (
    <div className="mb-4">
      <div className="text-[11px] font-medium text-gray-400 uppercase tracking-wide mb-1.5 ml-0.5">Pipeline funnel</div>
      <div className="grid gap-2.5" style={{ gridTemplateColumns: `repeat(auto-fit, minmax(120px, 1fr))` }}>
        {stages.map((stage, index) => (
          <StageMetricCard key={stage.stage_id} name={stage.stage_name} total={stage.total} conversionPct={pctOfLeads(stage.total, leadsTotal)} isFirst={index === 0} color={stageColor(index)} />
        ))}
      </div>
    </div>
  );
}
